import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useSelectorWithDispatch } from '@ers/hooks/';
import { getApplication, getApplicationsLoaded } from '@ers/pages/home/Home.selectors';
import { fetchApplications } from '@ers/pages/home/Home.actions';
import { CompanyAvatar, Typo, Spinner, FormatDate, Button, Recommendations, Media } from '@ers/ui';
import { Variants } from '@ers/ui/Typo';
import { useArchive } from '@ers/pages/home/Home.hooks';
import { ArrowBack, Archive, Unarchive } from '.';




const FormHeaderHooked = ({ applicationId }) => {
    const archived = useArchive();
    const loaded = useSelector((state) => getApplicationsLoaded(state, { archived }));
    const application = useSelectorWithDispatch(
        (state) => getApplication(state, { applicationId, archived }),
        fetchApplications(archived),
        (a) => !a && !loaded
    );

    return <FormHeader application={application} archived={archived} />;
};
FormHeaderHooked.propTypes = {
    applicationId: PropTypes.number
};
FormHeaderHooked.defaultProps = {
    applicationId: null
};

export default FormHeaderHooked;

export const FormHeader = ({ application, noReturn, archived }) => (
    <div className="application application-header">
        {application
            ? (
                <>
                    <div className="application-header__arrow-section">
                        <ArrowBack noReturn={noReturn} />
                        <CompanyAvatar>{application.companyName}</CompanyAvatar>
                        <div className="application__data">
                            <Typo.Subheader>{application.positionName}</Typo.Subheader>
                            <Typo.Body variant={Variants.LIGHT}>
                                {`${application.companyName} ･ ${application.source} ･ `}
                                <FormatDate date={new Date(application.applicationDate)} />
                            </Typo.Body>
                        </div>
                    </div>
                    <div className="application-header__actions">
                        {!noReturn && (
                            <>
                                {archived ? <Unarchive /> : <Archive />}
                                <Media not phone>
                                    <Button.Separator />
                                </Media>
                                <Recommendations applicationId={application.applicationId} positionName={application.positionName}>
                                    {(innerProps) => (
                                        <Recommendations.Button className="application-header__actions--recommendations" {...innerProps} />
                                    )}
                                </Recommendations>
                            </>
                        )}
                    </div>
                </>
            ) : (
                <div className="application-header__arrow-section">
                    <ArrowBack />
                    <Spinner />
                </div>
            )}
    </div>
);
FormHeader.propTypes = {
    application: PropTypes.shape({
        applicationId: PropTypes.number,
        companyName: PropTypes.string,
        positionName: PropTypes.string,
        source: PropTypes.string,
        applicationDate: PropTypes.string
    }),
    noReturn: PropTypes.bool,
    archived: PropTypes.bool,
};
FormHeader.defaultProps = {
    application: null,
    noReturn: false,
    archived: false,
};
